import api from './api';

export interface UpdateMyProfilePayload {
  firstName?: string;
  lastName?: string;
  phone?: string;
  avatar?: string;
}

export interface UserProfile {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

class UsersService {
  async updateMe(data: UpdateMyProfilePayload): Promise<UserProfile> {
    const response = await api.patch<UserProfile>('/users/me', data);
    return response.data;
  }

  async linkCompany(companyId: string): Promise<UserProfile> {
    const response = await api.post<UserProfile>('/users/me/link-company', { companyId });
    return response.data;
  }
}

export default new UsersService();
